{
  "melodicPattern": {
    "configuration": {
      "color": "Farbe",
      "confirmation": {
        "cancel": "Behalten",
        "delete": "Löschen",
        "title": "Bist du dir sicher?"
      },
      "description": "Beschreibung",
      "descriptionPlaceholder": "Beschreibe das melodische Motiv... (max. 280 Zeichen)",
      "disclaimer": "Standardmäßig wird die Farbe eines Motivs\ndurch die Farbe der Stimme bestimmt,\nin der das Motiv zuerst vorkommt.",
      "label": "Name",
      "length": "Länge",
      "occurrences": "Vorkommen (eindeutige)",
      "title": "Melodisches\nMotiv",
      "lock": "Muster im Graph fixieren",
      "delete": "Dieses Muster löschen",
      "deleteConfirm": "Muster {{label}} mit seinen Vorschlägen löschen?",
      "deleteSuggested": "Vorgeschlagene Muster verschwinden, wenn ihr Operator ausgeblendet oder ihr Muster gelöscht wird."
    },
    "tooltip": {
      "disclaimer": "Um die Sichtbarkeit dieses Motivs zu garantieren, erscheint es größer als es tatsächlich ist. Die Relation zu anderen Motiven wird daher nicht korrekt abgebildet."
    }
  },
  "melodyAnalysis": "Melodie Analyse",
  "melodyGraph": {
    "commonOccurrencesEdge_one": "{{ count }} gemeinsames Vorkommen",
    "commonOccurrencesEdge_other": "{{ count }} gemeinsame Vorkommen",
    "empty": "Noch keine Muster. Wähle im Notenblatt die erste und die letzte Note eines Musters: Das Muster, verwandte Muster und die Operatoren, die sie verbinden, erscheinen hier.",
    "controls": {
      "fit": "Graph einpassen",
      "unlockAll": "Alle Muster lösen",
      "focus": "Auf das ausgewählte Muster fokussieren",
      "entries": "Jeden Einsatz als eigenen Knoten zeigen"
    }
  },
  "musicSheets": {
    "Fugue No. 2 in C Minor (BWV 847)": "Fuge II in C-Moll (BWV 847)",
    "Goldberg Variations: Aria": "Goldberg Variationen: Aria",
    "Fugue No. 20 in A minor (BWV 889)": "Fuge XX in A-Moll (BWV 889)",
    "Samples": "Beispiele",
    "Study": "Studie",
    "Symphony No. 5 - 1st Movement": "5. Sinfonie - erster Satz",
    "Test": "Test",
    "title": "{{ title }} (von {{ composer }})",
    "The Four Seasons": "Die vier Jahreszeiten",
    "The Silver Swan": "Der silberne Schwan",
    "Waltz Opus 18 in E Major": "Waltz Opus 18 in E-Dur"
  },
  "onBoarding": {
    "step1": {
      "description": "Das ausgewählte Musikstück wird ähnlich wie auf dem Papier seitenweise angezeigt. Für die Melodieanalyse kannst du melodische Motive über deren erste und letzte Note durch einen Klick auswählen.",
      "title": "Musikstück"
    },
    "step2": {
      "description": "Du kannst die Seiten des Musikstücks durch Klicken auf die entsprechenden Buttons navigieren. Ebenfalls kannst du die Pfeiltasten auf deiner Tastatur verwenden, um die Seiten zu wechseln.",
      "title": "Navigation des Musikstücks"
    },
    "step3": {
      "description": "Die Melodie Zeitleiste gibt einen Überblick über das gesamte Musikstück. Vertikale Linien markieren die Umbrüche zwischen den Seiten des Musikstücks. Hoverst du links und rechts von diesen vertikalen Linien wird automatisch die entsprechende Seite des Musikstücks angezeigt. Melodische Motive, die du im Musikstück highlightest erscheinen automatisch in der Melodie Zeitleiste.",
      "title": "Melodie Zeitleiste"
    },
    "step4": {
      "description": "Die Vorschläge zeigen acht melodische Operatoren, mit deren Hilfe du basierend auf einem ausgewählten melodischen Motiv andere melodische Motive finden kannst. Standardmäßig zeigt der Prototyp nur die anderen melodischen Motive, die durch Transposition gefunden werden. Andere melodische Operatoren kannst du durch einen Klick auf deren Bild auswählen. Hoverst du mit deiner Maus über ein solches Bild ohne zu klicken, wird eine Vorschau der entsprechenden melodischen Motive angezeigt.",
      "title": "Vorschläge"
    },
    "step5": {
      "description": "Der Melodie Graph zeigt alle gehighlighteten melodischen Motive als Knoten. Highlightest du ein melodisches Motiv mittels der Vorschläge, wird es mit einem anderen melodischen Motiv über den entsprechenden melodischen Operator verbunden.",
      "title": "Melodie Graph"
    },
    "step6": {
      "description": "Die melodische Motiv Konfiguration ermöglicht es dir, die Bezeichnung, die Beschreibung sowie die Farbe eines melodischen Motivs zu verändern. Du kannst ein melodisches Motiv auch löschen, indem du rechts auf den Mülleimer klickst.",
      "title": "Melodisches Motiv Konfiguration"
    },
    "tooltip": {
      "back": "Zurück",
      "close": "Schließen",
      "next": "Weiter",
      "skip": "Überspringen",
      "progress": "{{current}} von {{total}}"
    },
    "discovery": {
      "title": "Gefundene Muster",
      "description": "MelodyVis analysiert jedes Stück automatisch: Themen, Kontrasubjekte, Imitationen, Sequenzen und Motive mit all ihren Einsätzen. Zeige eine Familie im Notenblatt, hör sie dir an oder wähle sie aus, um zu sehen, wie sie durch die Stimmen wandert, wie sie transponiert oder verändert wird und auf welchen Tönen sie beginnt."
    }
  },
  "settings": {
    "colorByVoice": "Motive gemäß Stimme einfärben",
    "colorVoices": "Stimmen im Musikstück einfärben"
  },
  "suggestions": {
    "accept": "Annehmen",
    "decline": "Verwerfen",
    "generate": "Generieren",
    "operators": {
      "all": {
        "title": "Alle"
      },
      "augmentation": {
        "description": "Verdoppelt Länge aller Noten",
        "title": "Augmentation"
      },
      "deviation": {
        "description": "Erlaubt Abweichung des Motivs in bis zu <0>{{ deviationPercentage }} %</0> der Noten",
        "disclaimer": "Bei einem geringen Prozentsatz erlaubt der Operator weniger Abweichung, bei einem höheren Prozentsatz ist das Gegenteil der Fall.",
        "title": "Abweichung"
      },
      "diminution": {
        "description": "Halbiert Länge aller Noten",
        "title": "Diminution"
      },
      "mirror_x": {
        "description": "Spiegelt Tonhöhen an der x-Achse der ersten Note",
        "title": "Spiegelung an x-Achse"
      },
      "mirror_y": {
        "description": "Spiegelt Noten an der y-Achse der mittleren Note(n)",
        "title": "Spiegelung an y-Achse"
      },
      "mirror_xy": {
        "title": "Spiegelung an beiden Achsen",
        "description": "Umkehrung und Krebs kombiniert (Krebsumkehrung)"
      },
      "reduction_to_pitch": {
        "description": "Berücksichtigt nur Tonhöhen des Motivs",
        "title": "Reduktion zu Tonhöhe"
      },
      "reduction_to_rhythm": {
        "description": "Berücksichtigt nur Rhythmus des Motivs",
        "title": "Reduktion zu Rhythmus"
      },
      "transposition": {
        "description": "Transponiert das Motiv um bestimmtes, aber beliebiges Intervall",
        "title": "Transposition"
      }
    },
    "title": "Vorschläge",
    "useAsDefault": "Als Standard festlegen",
    "useAsDefaultTooltip": "Diese Einstellung der Sichtbarkeit von verwandten melodischen Motiven wird für alle neuen melodischen Motive verwendet.",
    "deviationThreshold": "Abweichungsgrenze: {{percentage}} %",
    "tonal": "Tonale Varianten",
    "tonalTooltip": "An: Transpositionen, Umkehrungen, Krebse und Abweichungen dürfen statt der exakten Intervalle die Tonleiterstufen beibehalten, z. B. die tonale Beantwortung einer Fuge. Aus: nur exakte Intervalle in Halbtönen. Gilt für die nächste Suche.",
    "hint": "Wähle ein Motiv im Notenblatt oder eine entdeckte Familie, um ihre Varianten zu sehen.",
    "family": {
      "summary": "{{entries}}: {{self}} wie notiert (erster Einsatz, exakte Wiederholungen), {{related}} über die Operatoren unten verwandt.",
      "hidden": "Diese Familie ist im Notenblatt nicht eingeblendet.",
      "show": "Im Notenblatt zeigen",
      "all": "Zeigt oder verbirgt die Markierungen aller verwandten Einsätze; der erste Einsatz und exakte Wiederholungen bleiben.",
      "toggle_one": "Markierung des {{count}} so verwandten Einsatzes zeigen oder verbergen",
      "toggle_other": "Markierungen der {{count}} so verwandten Einsätze zeigen oder verbergen",
      "none": "Kein Einsatz von {{label}} ist so mit seinem ersten Einsatz verwandt.",
      "notSearched": "Die automatische Erkennung sucht nicht nach dieser Verwandtschaft. Wähle das Motiv im Notenblatt aus, um danach zu suchen.",
      "deviation": "Varianten: bis zu 20 % der Noten weichen ab",
      "searchHint": "Um mit allen Operatoren zu suchen, wähle Noten im Notenblatt aus."
    }
  },
  "discovery": {
    "title": "Gefundene Muster",
    "summary_one": "{{count}} Musterfamilie erklärt {{share}} % der Noten",
    "summary_other": "{{count}} Musterfamilien erklären {{share}} % der Noten",
    "accompanies": "erklingt gegen {{label}}",
    "roles": {
      "theme": "Thema",
      "countersubject": "Kontrasubjekt",
      "imitation": "Imitation (Kanon)",
      "sequence": "Sequenz",
      "motif": "Motiv"
    },
    "show": "Im Notenblatt zeigen",
    "hide": "Im Notenblatt ausblenden",
    "showAll": "Alle zeigen",
    "hideAll": "Alle ausblenden",
    "play": "Ersten Einsatz abspielen",
    "stop": "Stopp",
    "none": "In diesem Stück wurden keine wiederholten Muster gefunden.",
    "failed": "Die automatische Analyse ist fehlgeschlagen: {{error}}",
    "computing": "Das Stück wird analysiert…",
    "patternDescription_one": "{{role}}, {{count}} Einsatz in den Takten {{bars}}, automatisch gefunden.",
    "patternDescription_other": "{{role}}, {{count}} Einsätze in den Takten {{bars}}, automatisch gefunden.",
    "notes_one": "{{count}} Note",
    "notes_other": "{{count}} Noten",
    "yours_one": "dein Muster {{labels}}",
    "yours_other": "deine Muster {{labels}}",
    "yoursTooltip": "Einsätze dieser Familie überschneiden sich mit Mustern, die du ausgewählt hast.",
    "next": "Noch nicht in deiner Analyse: {{labels}}",
    "rename": "Umbenennen",
    "renameField": "Name von {{label}}",
    "renamePlaceholder": "Leer lassen für den Startnamen",
    "figures": {
      "head": "Kopfmotiv von {{source}}",
      "tail": "Schlussmotiv von {{source}}",
      "part": "Motiv aus {{source}}",
      "inverted": "{{name}}, umgekehrt",
      "repetition": "Tonrepetition (Repetitio)",
      "chromatic_up": "Chromatischer Gang aufwärts (Passus duriusculus)",
      "chromatic_down": "Chromatischer Gang abwärts (Passus duriusculus)",
      "scale_up": "Steigende Linie",
      "scale_down": "Fallende Linie",
      "tirata_up": "Lauf aufwärts (Tirata)",
      "tirata_down": "Lauf abwärts (Tirata)",
      "arpeggio_up": "Dreiklangsbrechung aufwärts",
      "arpeggio_down": "Dreiklangsbrechung abwärts",
      "sigh": "Seufzer (Suspiratio)",
      "sighs": "Seufzerkette",
      "neighbour_up": "Obere Wechselnote",
      "neighbour_down": "Untere Wechselnote",
      "turn": "Drehfigur (Circulatio)",
      "leap_up": "{{interval}}sprung aufwärts",
      "leap_down": "{{interval}}sprung abwärts",
      "exclamatio": "{{name}} (Exclamatio)",
      "contour_rising": "Steigendes Motiv",
      "contour_falling": "Fallendes Motiv",
      "contour_arch": "Bogenmotiv",
      "contour_valley": "Muldenmotiv",
      "contour_level": "Kreisendes Motiv",
      "sequence_up": "Steigende Sequenz in {{interval}}",
      "sequence_down": "Fallende Sequenz in {{interval}}",
      "rhythm_dotted": "{{name}}, punktiert",
      "rhythm_corta": "{{name}}, Figura corta",
      "fromHead": "Motiv aus dem Kopf von {{source}}"
    },
    "leapIntervals": {
      "fourth": "Quart",
      "tritone": "Tritonus",
      "fifth": "Quint",
      "sixth": "Sext",
      "seventh": "Septim",
      "octave": "Oktav"
    },
    "sequenceIntervals": {
      "second": "Sekunden",
      "third": "Terzen",
      "fourth": "Quarten",
      "fifth": "Quinten",
      "large": "großen Schritten"
    }
  },
  "import": {
    "title": "Noten importieren",
    "submit": "Importieren",
    "file": "MusicXML-Datei",
    "drop": "MusicXML-Datei hier ablegen oder klicken",
    "hint": ".musicxml, .xml oder komprimiertes .mxl, bis 10 MB (z. B. aus MuseScore exportiert)",
    "titleLabel": "Titel",
    "composer": "Komponist",
    "fromFile": "Leer lassen, um ihn aus der Datei zu übernehmen.",
    "button": "Importieren"
  },
  "tabs": {
    "operators": "Operatoren & Graph",
    "transitions": "Übergänge des Musters"
  },
  "transitions": {
    "hint": "Klicke ein gefundenes Muster im Notenblatt oder in der Zeitleiste an oder wähle ein eigenes (erste und letzte Note einer Stimme), um zu sehen, wie es sich durch das Stück bewegt.",
    "loading": "Die Einsätze des Musters werden gesucht…"
  },
  "language": "Sprache",
  "analysis": {
    "menu": "Analyse",
    "export": "Analyse exportieren (.json)",
    "import": "Analyse importieren (.json)",
    "otherPiece": "Diese Analyse gehört zu „{{title}}“. Öffne zuerst dieses Stück.",
    "imported_one": "{{count}} Muster importiert.",
    "imported_other": "{{count}} Muster importiert.",
    "invalid": "Die Analyse konnte nicht importiert werden: {{reason}}"
  },
  "family": {
    "section": "Muster {{label}}",
    "summary": "{{entries}} in {{voices}}, Takte {{first}}–{{last}}: {{same}} gleich, {{transposed}} transponiert, {{changed}} verändert.",
    "entries_one": "{{count}} Einsatz",
    "entries_other": "{{count}} Einsätze",
    "voices_one": "{{count}} Stimme",
    "voices_other": "{{count}} Stimmen",
    "sequences_one": "{{count}} Sequenz (aufeinanderfolgende transponierte Einsätze).",
    "sequences_other": "{{count}} Sequenzen (aufeinanderfolgende transponierte Einsätze).",
    "imitations_one": "{{count}} Imitation (zeitlich überlappende Einsätze).",
    "imitations_other": "{{count}} Imitationen (zeitlich überlappende Einsätze).",
    "strip": "Einsätze von Muster {{label}} pro Stimme im Zeitverlauf",
    "voice": "Stimme {{voice}}",
    "voiceShort": "{{voice}}",
    "classes": {
      "same": "Gleiche Töne (erster Einsatz, exakt oder Oktavkopie)",
      "transposed": "Transponiert (real oder tonal)",
      "changed": "Verändert (Variante, Umkehrung, Krebs, Rhythmus)"
    },
    "byVoice": "Einsätze pro Stimme",
    "bySemitones": "Tonlage zum 1. Einsatz (Halbtöne)",
    "byStart": "Anfangston (Tonartbereiche)",
    "table": "Einsätze von Muster {{label}}",
    "columns": {
      "voice": "Stimme",
      "bars": "Takte",
      "start": "Beginnt auf",
      "relation": "Beziehung",
      "play": "Abspielen"
    },
    "playEntry": "Einsatz {{index}} abspielen",
    "where": "Stimme {{voice}}, Takt {{bars}}, beginnt auf {{pitch}}",
    "rest": "einer Pause",
    "semitones": "{{shift}} Halbtöne",
    "relations": {
      "prototype": "erster Einsatz",
      "exact": "exakte Wiederholung",
      "real": "reale Transposition",
      "tonal": "tonale Transposition",
      "variant_one": "Variante mit {{count}} geänderter Note",
      "variant_other": "Variante mit {{count}} geänderten Noten",
      "inversion": "Umkehrung",
      "retrograde": "Krebs",
      "augmentation": "Augmentation",
      "diminution": "Diminution"
    },
    "glyphs": {
      "prototype": "1.",
      "tonal": "t",
      "inversion": "Umk",
      "retrograde": "Kr"
    }
  },
  "views": {
    "sheet": "Das Notenblatt",
    "timeline": "Die Zeitleiste",
    "discovery": "Die gefundenen Muster",
    "operators": "Die Operatoren und der Graph",
    "transitions": "Die Übergänge"
  },
  "errorBoundary": {
    "title": "{{name}} konnte nicht angezeigt werden",
    "retry": "Erneut versuchen"
  },
  "timeline": {
    "page": "Seite {{page}}",
    "playHint": "Doppelklick spielt diesen Einsatz ab."
  },
  "toolbar": {
    "tour": "Tour starten",
    "exportPDF": "Notenblatt mit den Mustern als PDF exportieren",
    "deleteAll": "Alle Muster löschen",
    "deleteAllConfirm": "Alle Muster dieses Stücks löschen?",
    "delete": "Löschen",
    "cancel": "Abbrechen",
    "settings": "Darstellung"
  },
  "musicSheetError": {
    "title": "Dieses Stück konnte nicht geöffnet werden",
    "retry": "Erneut versuchen"
  },
  "musicSheetSelection": {
    "label": "Musikstück"
  },
  "audio": {
    "credit": "Klavier: Salamander Grand Piano von Alexander Holm,",
    "failed": "Der Einsatz kann nicht abgespielt werden: {{reason}}"
  },
  "piece": {
    "player": "Wiedergabe des Stücks",
    "play": "Stück abspielen",
    "playFromPage": "Ab dieser Seite abspielen",
    "pause": "Pause",
    "resume": "Weiter",
    "stop": "Stück anhalten",
    "tempo": "Tempo (Viertel pro Minute)",
    "bar": "Takt {{bar}}",
    "failed": "Das Stück kann nicht abgespielt werden: {{reason}}"
  },
  "pageMode": {
    "group": "Seiten der Noten",
    "a4": "A4",
    "a4Hint": "Gedruckte A4-Seiten: Zeilen- und Seitenumbrüche bleiben, der Zoom vergrößert nur das Blatt",
    "fit": "Ansicht",
    "fitHint": "Seiten füllen die Ansicht: der Zoom ändert die Takte pro Zeile, nie seitliches Scrollen"
  },
  "sheetZoom": {
    "group": "Zoom der Noten",
    "zoomIn": "Vergrößern (+, Strg + Mausrad)",
    "zoomOut": "Verkleinern (-, Strg + Mausrad)",
    "original": "Originalgröße (0)"
  }
}
